/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Current_Role_As_LabelInputs */

const en_current_role_as_label = /** @type {(inputs: Current_Role_As_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current role as`)
};

const es_current_role_as_label = /** @type {(inputs: Current_Role_As_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rol actual`)
};

/**
* | output |
* | --- |
* | "Current role as" |
*
* @param {Current_Role_As_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const current_role_as_label = /** @type {((inputs?: Current_Role_As_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_Role_As_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_current_role_as_label(inputs)
	return es_current_role_as_label(inputs)
});